import { useState, useEffect } from "react";
import { fetchCompaniesApi, fetchSecurityAnalystsCompanyApi } from "../../services/axios/AuthApis/AdministrationApis";
import { useSelector } from "react-redux";
import CompanyAutoComplete from "./CompanyAutoComplete";

const SecurityAnalystForm = ({
  newUser,
  setNewUser,
  errors,
  setErrors,
  selectedCompanies,
  setSelectedCompanies,
  isEdit,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCompanies, setLoadingCompanies] = useState(false)
  const userId = newUser?.id;
  useEffect(() => {
    getSelectedCompany();
  }, []);
  const getSelectedCompany = async () => {
    try {
      setLoadingCompanies(true)
      if (!userId) {
        setSelectedCompanies([]);
        return;
      }
      const res = await fetchSecurityAnalystsCompanyApi(userId)
      if (res) {
        setSelectedCompanies(res.data);
      } else {
        setSelectedCompanies([]);
      }
    } catch (err) {
      console.error("Error :", err)
    } finally {
      setLoadingCompanies(false)
    }
  }
  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchTerm.trim().length >= 2) {
        setLoading(true);
        const selectedCompaniesId = selectedCompanies.map((comp) => comp.id)
        fetchCompaniesApi(searchTerm, selectedCompaniesId)
          .then(data => {
            setCompanies(data.results);
            setLoading(false);
          })
          .catch(err => {
            console.error(err);
            setLoading(false);
          });
      } else {
        setCompanies([]);
      }
    }, 300);

    return () => clearTimeout(handler);
  }, [searchTerm]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setShowDropdown(true);
  };

  const handleSelectCompany = (company) => {
    if (!selectedCompanies.map(c => c.id).includes(company.id)) {
      setSelectedCompanies(prev => [...prev, company]);
    }

    setSearchTerm("");
    setShowDropdown(false);
    setErrors(prev => ({ ...prev, company: undefined }));
  };

  const handleRemoveCompany = (id) => {
    setSelectedCompanies(prev => prev.filter(c => c.id !== id));
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Analyst Name <span className="text-red-500">*</span>
        </label>

        <input
          type="text"
          maxLength={250}
          value={newUser.firstname}
          onChange={(e) => {
            setNewUser({ ...newUser, firstname: e.target.value });
            setErrors(prev => ({ ...prev, firstname: undefined }));
          }}
          className={`w-full border rounded-lg px-3 py-2 ${errors.firstname ? "border-red-500" : "border-gray-300"
            }`}
          placeholder="Enter first name"
        />

        {errors.firstname && (
          <p className="text-red-500 text-xs mt-1">
            {errors.firstname}
          </p>
        )}
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Email<span className="text-red-500">*</span></label>
        <input
          type="email"
          value={newUser.email}
          readOnly={isEdit}
          onChange={isEdit ? undefined : (e) => {
            setNewUser({ ...newUser, email: e.target.value });
            setErrors((prev) => ({ ...prev, email: undefined }));
          }}
          className={`w-full border rounded-lg px-3 py-2 ${errors.email ? "border-red-500" : "border-gray-300"} ${isEdit ? "bg-gray-50 text-gray-500 cursor-not-allowed" : ""}`}
          placeholder="Enter email address"
        />
        {errors.email && (
          <p className="text-red-500 text-xs mt-1">{errors.email}</p>
        )}
      </div>
      <div className="md:col-span-2">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Customer Name <span className="text-red-500">*</span>
        </label>
        <CompanyAutoComplete
          searchTerm={searchTerm}
          handleSearchChange={handleSearchChange}
          handleSelectCompany={handleSelectCompany}
          companies={companies}
          handleRemoveCompany={handleRemoveCompany}
          selectedCompanies={selectedCompanies}
          loading={loading}
          errors={errors}
          type="multi-select"
          loadingCompanies={loadingCompanies}
          setShowDropdown={setShowDropdown}
          showDropdown={showDropdown}
        />

        {errors.company && (
          <p className="text-red-500 text-xs mt-1">{errors.company}</p>
        )}
      </div>
    </div>
  );
};

export default SecurityAnalystForm;